module.exports = __webpack_public_path__ + "static/media/to_configure_36980.e23ee822.png";